import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "link"]

  toggle() {
    this.menuTarget.classList.toggle("hidden")
  }

  close() {
    this.menuTarget.classList.add("hidden")
  }
}